import {
  MILITARY_TIME_REGEX,
  STANDARD_TIME_REGEX,
  TimeFormatOptions,
} from 'shared/types/date-format-options';

export const isValidTime = (
  input: string,
  timeFormat: TimeFormatOptions,
): boolean => {
  if (timeFormat === TimeFormatOptions.Military) {
    // 24-hour format: HH:MM (00:00 to 23:59)
    return MILITARY_TIME_REGEX.test(input);
  } else {
    // 12-hour format: h:MM AM/PM (1:00 AM to 12:59 PM)
    // Case-insensitive and flexible spacing between time and AM/PM
    return STANDARD_TIME_REGEX.test(input);
  }
};
